import React from "react";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { useBottomSheet } from "@danishagro/shared/src/contexts/bottomSheet/bottomSheet.context";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_MiniSearch } from "@danishagro/shared/src/components/organisms/SiteHeader/MiniSearch/MiniSearch.component";
import { useSiteHeader } from "@danishagro/shared/src/contexts/siteHeader.context";
import { DA_MiniSearchB2c } from "@danishagro/shared/src/components/organisms/SiteHeader/MiniSearchB2c/MiniSearchB2c.component";
import { DA_MiniSearchB2bStyle } from "@danishagro/shared/src/components/organisms/SiteHeader/MiniSearchB2bStyle/MiniSearchB2bStyle.component";

export const useSearchButton = () => {
    const { getDictionaryString } = useTranslations();
    const { closeMobileNav, showMobileNav } = useSiteHeader();
    const { currentSite } = useAppData();

    const { presentBottomSheet, dismissBottomSheet, activeBottomSheet } = useBottomSheet();

    const b2cSite = currentSite === "B2C";
    const useB2bStyleSearch =
        globalThis.searchPageVersion === "v1" &&
        (currentSite === "B2B" || currentSite === "MYFARM");

    const onSearchButtonClicked = () => {
        const id = "search";

        if (activeBottomSheet !== id) {
            let searchComponent;
            if (b2cSite) {
                searchComponent = <DA_MiniSearchB2c />;
            } else if (useB2bStyleSearch) {
                searchComponent = <DA_MiniSearchB2bStyle />;
            } else {
                searchComponent = <DA_MiniSearch />;
            }

            presentBottomSheet(searchComponent, {
                id: id,
                headerTitle: getDictionaryString("searchModalTitle"),
            });
            // Close mobileNav after bottomSheet has opened
            if (showMobileNav) {
                setTimeout(() => {
                    closeMobileNav();
                }, 500);
            }
        } else {
            dismissBottomSheet();
        }
    };

    return {
        showSearch: true,
        onSearchButtonClicked,
        isSearchMenuActive: false,
    };
};
